import PermanentBanIcon from "@/assets/colorable/permanent_ban.svg?react";
import ProbationIcon from "@/assets/colorable/probation.svg?react";
import TimedBanIcon from "@/assets/colorable/timed_ban.svg?react";
import InstagramIcon from "@/assets/colorable/unverified_instagram.svg?react";
import TiktokIcon from "@/assets/colorable/unverified_tiktok.svg?react";
import UGCIcon from "@/assets/colorable/unverified_ugc.svg?react";
import UnverifyIcon from "@/assets/colorable/unverify.svg?react";
import clsxm from "@/lib/clsxm";
import type {TPunishmentType} from "@/store/types";
import {getDisciplineColor} from "@/utils/disciplineUtils";
import {memo, useMemo, type FC} from "react";

const DisciplineMark: FC<{
  className?: string;
  type: TPunishmentType | "GENERAL_UNVERIFIED";
  variant?: "outline" | "fill";
}> = ({className, type, variant = "fill"}) => {
  const Icon = useMemo(() => {
    const style = {color: variant === "outline" ? `var(--color-${getDisciplineColor(type)})` : "white"};

    switch (type) {
      case "PERMANENT_BAN":
        return <PermanentBanIcon style={style} />;
      case "PROBATION":
        return <ProbationIcon style={style} />;
      case "TIMED_BAN":
        return <TimedBanIcon style={style} />;
      case "UN_VERIFIED_INSTAGRAM":
        return <InstagramIcon style={style} />;
      case "UN_VERIFIED_TIKTOK":
        return <TiktokIcon style={style} />;
      case "UN_VERIFIED_UGC":
        return <UGCIcon style={style} />;
      default:
        return <UnverifyIcon style={style} />;
    }
  }, [type, variant]);

  return (
    <div
      className={clsxm("flex size-8 items-center justify-center rounded-md", className)}
      style={{backgroundColor: variant === "outline" ? "" : `var(--color-${getDisciplineColor(type)})`}}>
      {Icon}
    </div>
  );
};

export default memo(DisciplineMark);
